import { makeStyles } from "@mui/styles";
export default makeStyles(theme=>({
    channelTitle: {
        color: theme.palette.mode==='light'?'#000':'#fff',
        textAlign: 'center',
        position: 'absolute',
        top: '65px',
        // left: '2%'
    }
}));